import React, { useEffect, useRef } from "react";
import "intersection-observer";
import "./Styles/App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// TEMPLATES
import { LoaderPage } from "./Components/Loader";
import { Footer } from "./Components/Footer/Footer";
import { Header } from "./Components/Header/Header";

import ScrollToTop from "./Utils/ScrollToTop";
import { RouteForTemplates } from "./Utils/RouteForTemplates";

// GA
import ReactGA from "react-ga";

// Hooks
import { useApi } from "./Hooks/useApi";
import { useSelector, useDispatch } from "react-redux";
import {
  updateGlobalStoreGlobal,
  updateGlobalisLoaded,
  updateGlobalStoreRoutes,
  updateGlobalScrollLock,
  updateIsMobile,
  updateIsTablet,
  updateIsDesktop,
  updateIsDesktopWide,
  updateGA,
  updateLang,
} from "./Store/action";
import Test from "./Components/Test";

const App = () => {
  let dispatch = useDispatch();
  let appRef = useRef();

  let { routes, event, isLoaded, lockScroll, app } = useSelector(
    (state) => state.global
  );
  let { mobile, tablet, desktop, desktopWide } = useSelector(
    (state) => state.breakpoint
  );
  let [dataGlobalAPI, dataGlobalIsLoaded] = useApi({ name: "global" });
  let [dataRoutesAPI, routesIsLoaded] = useApi({
    name: "routes",
    isRoute: true,
  });
  // let {google_analytics} = dataGlobalAPI;

  // API DISPATCHES
  useEffect(() => {
    dispatch(updateGlobalStoreGlobal(dataGlobalAPI));
  }, [dispatch, dataGlobalAPI]);

  useEffect(() => {
    dispatch(updateGlobalStoreRoutes(dataRoutesAPI));
  }, [dispatch, dataRoutesAPI]);

  useEffect(() => {
    dispatch(updateGlobalisLoaded(routesIsLoaded && dataGlobalIsLoaded));

    window.prerenderReady = true;
  }, [dispatch, routesIsLoaded, dataGlobalIsLoaded]);

  useEffect(() => {
    if (window.tarteaucitron) {
      let timer = setInterval(() => {
        if (window.tarteaucitron.state["gtag"] === true) {
          ReactGA.initialize("UA-4100966-6", {
            // debug: true,
            // titleCase: false,
          });
          dispatch(updateGA(true));
          clearInterval(timer);
        }
      }, 250);
    }
  }, []);

  /*// Activate Google Analytics
    useEffect(() => {
        ReactGA.set({page: window.location.pathname});
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [google_analytics]);*/

  // RESIZE
  useEffect(() => {
    const checkDevice = () => {
      if (window.matchMedia("(max-width:767px)").matches && !mobile) {
        dispatch(updateIsMobile(true));
        dispatch(updateIsTablet(false));
        dispatch(updateIsDesktop(false));
        dispatch(updateIsDesktopWide(false));
      }
      if (
        window.matchMedia("(min-width:768px) and (max-width:1024px)").matches &&
        !tablet
      ) {
        dispatch(updateIsMobile(false));
        dispatch(updateIsTablet(true));
        dispatch(updateIsDesktop(false));
        dispatch(updateIsDesktopWide(false));
      }
      if (
        window.matchMedia("(min-width:1025px) and (max-width: 1365px)")
          .matches &&
        !desktop
      ) {
        dispatch(updateIsMobile(false));
        dispatch(updateIsTablet(false));
        dispatch(updateIsDesktop(true));
        dispatch(updateIsDesktopWide(false));
      }
      if (window.matchMedia("(min-width:1366px)").matches && !desktopWide) {
        dispatch(updateIsMobile(false));
        dispatch(updateIsTablet(false));
        dispatch(updateIsDesktop(false));
        dispatch(updateIsDesktopWide(true));
      }
    };

    checkDevice();

    window.addEventListener("resize", checkDevice);

    // clean listener
    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, [dispatch, desktop, desktopWide, mobile, tablet]);

  useEffect(() => {
    dispatch(updateGlobalScrollLock(lockScroll));

    if (lockScroll) {
      document.documentElement.classList.add("scrollLocked");
      document.body.classList.add("scrollLocked");
      document.body.style.height = window.innerHeight + "px";
    } else {
      document.documentElement.classList.remove("scrollLocked");
      document.body.classList.remove("scrollLocked");
      document.body.style.height = null;
    }
  }, [dispatch, lockScroll]);

  useEffect(() => {
    let path;

    window.pathArticle
      ? (path = window.pathArticle)
      : (path = window.location.pathname);

    let toSplit = path.split("/");
    let toDispatch;

    toSplit[1] === "en" ? (toDispatch = "en") : (toDispatch = "fr");

    dispatch(updateLang(toDispatch));
  }, [dispatch]);

  return (
    <div
      id="main-app"
      className={`app${
        event.banners && event.banners.length > 0 && !app
          ? " has-event"
          : app
          ? " mobile-app"
          : ""
      }`}
      ref={appRef}>
      <LoaderPage load={isLoaded} />
      <Router>
        {isLoaded && (
          <>
            <ScrollToTop>
              {!app && <Header />}
              <Switch>
                {routes &&
                  routes.map((route) => {
                    return <RouteForTemplates key={route._uid} {...route} />;
                  })}
              </Switch>
              {!app && <Footer />}
            </ScrollToTop>
          </>
        )}
      </Router>
    </div>
  );
};

export default App;
